<div class="page-wrapper">
  <div class="page-title">Change Password</div>

  <div class="card">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <!-- New Password -->
      <div class="field-group">
        <label class="field-label" for="newPassword">New Password</label>

        <div class="input-wrapper" [class.error]="newPasswordInvalid">
          <input
            id="newPassword"
            [type]="showNewPassword ? 'text' : 'password'"
            formControlName="newPassword"
            placeholder="Enter your new password"
            (input)="onNewPasswordInput()"
          />

          <button
            type="button"
            class="eye-btn"
            (click)="showNewPassword = !showNewPassword"
          >
            @if (!showNewPassword) {
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            } @else {
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8
                  a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12
                  4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07
                  a3 3 0 1 1-4.24-4.24"
                />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
            }
          </button>
        </div>

        @if (showPasswordValidation) {
          <p class="validation-hint">
            Please add all necessary characters to create safe password.
          </p>

          <ul class="rules-list">
            <li [class.fail]="hasError('minLength')">Minimum characters 8</li>

            <li [class.fail]="hasError('uppercase')">
              One uppercase character
            </li>

            <li [class.fail]="hasError('lowercase')">
              One lowercase character
            </li>

            <li [class.fail]="hasError('special')">One special character</li>

            <li [class.fail]="hasError('number')">One number</li>
          </ul>
        }
      </div>

      <!-- Confirm New Password -->
      <div class="field-group">
        <label class="field-label" for="confirmPassword">
          Confirm New Password
        </label>

        <div class="input-wrapper" [class.error]="confirmMismatch">
          <input
            id="confirmPassword"
            [type]="showConfirmPassword ? 'text' : 'password'"
            formControlName="confirmPassword"
            placeholder="Enter your confirm new password"
            (input)="onConfirmPasswordInput()"
          />

          <button
            type="button"
            class="eye-btn"
            (click)="showConfirmPassword = !showConfirmPassword"
          >
            @if (!showConfirmPassword) {
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            } @else {
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8
                  a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12
                  4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07
                  a3 3 0 1 1-4.24-4.24"
                />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
            }
          </button>
        </div>

        @if (confirmMismatch) {
          <p class="validation-hint">Passwords do not match.</p>
        }
      </div>

      <!-- Revoke Sessions -->
      <div class="field-group">
        <label class="checkbox-wrapper" for="revokeSessions">
          <input
            id="revokeSessions"
            type="checkbox"
            formControlName="revokeSessions"
          />

          <span>Revoke all active sessions after password change</span>
        </label>
      </div>

      <!-- Submit -->
      <button
        type="submit"
        class="submit-btn"
        [disabled]="form.invalid || loading"
      >
        {{ loading ? "Changing..." : "Change Password" }}
      </button>
    </form>
  </div>
</div>
